/**
 * What a block draws when it has nothing to draw (docs/00-project-rules/02 §6.4).
 *
 * 🚨 "nobody measured" is not "measured zero": this box says WHAT is missing — a day that was
 * never scraped, a filter that matches nothing — instead of painting a confident 0.
 */
export function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="rounded-xl border border-dashed border-border p-6 text-center">
      <p className="text-foreground">{title}</p>
      {hint !== undefined && <p className="mt-1 text-[13px] text-muted-foreground">{hint}</p>}
    </div>
  );
}
